export const PAGE_ENTER_ANIMATION_DURATION = 0.3;
export const PAGE_EXIT_ANIMATION_DURATION = 0.45;
export const WHAT_WE_DO_NAV_LINK_ID = 2;
